<template>
  <!-- <div class="p-l-r-20" v-loading="!UserInfo">  -->
  <div class="p-l-r-20">
    <el-row class>
      <el-col :span="4">
        <div @click="goBack" class="pointer">
          <i class="el-dialog__close el-icon el-icon-close" id="close_profile"></i>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="fs-dp-in-bl">
          <!-- {{ $i18n.locale }} -->
        </div>
      </el-col>
      <el-col :span="4" class="text-right" style="line-height: 75px;">
        <img v-if="$i18n.locale == 'en'" @click="toggleLanguage('th')" class="fs-al-md" width="26" height="26" src="@/assets/icons/en.jpg"/>
        <img v-else @click="toggleLanguage('en')" class="fs-al-md" width="26" height="26" src="@/assets/icons/th.jpg"/>
      </el-col>
    </el-row>
    <el-row class="p-b-20" v-if="UserInfo">
      <el-col :span="22">
        <label class="text-title--large">{{ (UserInfo.name == 'ไม่ระบุชื่อ') ? ($i18n.locale === 'en') ? 'Unknow name' : UserInfo.nam : UserInfo.name }}</label> <br>
        <span class="text-heading3">{{ UserInfo.phone }}</span>
      </el-col>
      <el-col :span="2">
        <img src="@/assets/icons/edit.png"  v-if="false" class="fs-edit-icon"> 
      </el-col>
    </el-row>
		<el-row>
			<el-col class="fs-user-profile_page">
				<li @click="toggle_credit">
          <img class="fs-icon logout" src="@/assets/icons/credit.png"> 
          <label class="text-heading3">{{ $t('profile.creditcard') }}</label> 
          <i class="fas fa-chevron-right"></i>
        </li>
				<!-- <li @click="goHistoryOrder"><img class="fs-icon paid" src="@/assets/icons/paid.png"> <label>ออเดอร์ของฉัน</label> <i class="fas fa-chevron-right"></i></li> -->
				<li v-if="false">
          <img class="fs-icon logout" src="@/assets/icons/heart.png"> 
          <label class="text-heading3">{{ $t('profile.favmenu') }} </label> 
          <i class="fas fa-chevron-right"></i>
        </li>
				<li @click="toggle_policy" >
          <img class="fs-icon logout" src="@/assets/icons/shield.png"> 
          <label class="text-heading3">Term & Policies</label> 
          <i class="fas fa-chevron-right"></i>
        </li>
				<li @click="logoutUser">
          <img class="fs-icon logout" src="@/assets/icons/logout.png"> 
          <label class="text-heading3">{{ $t('profile.logout') }}</label> 
          <i class="fas fa-chevron-right"></i>
        </li>
			</el-col>
		</el-row>
    <DrawerListCreditCard v-if="is_creditcard" :is_credit="is_creditcard" @toggle_creditcard="toggle_credit" />
    <DrawerPolicy v-if="is_policy" :is_policy="is_policy" @toggle_policy="toggle_policy" />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import DrawerListCreditCard from '@/components/creditcard/DrawerListCreditCard'
import DrawerPolicy from '@/components/profile/DrawerPolicy'

export default {
  data(){
    return {
      UserLogin: null,
      is_creditcard: false,
      is_policy: false
    }
  },
  props: ['restaurant_uuid', 'branch_uuid'],
  components: {
    DrawerListCreditCard,
    DrawerPolicy
  },
  methods: {
    logoutUser() {
      firebase.auth().signOut()
      this.goMenu()
    },
    toggle_credit () {
      this.is_creditcard = !this.is_creditcard
    },
    toggle_policy () {
      this.is_policy = !this.is_policy
    },
    goBack() {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}` })
    },
    goMenu() {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}` })
    },
    goHistoryOrder () {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/order/history` })
    },
    toggleLanguage (lang) {
      this.$store.dispatch('setLanguage', lang)
      return this.$store.dispatch('startLoading')
    }
  },
  mounted() {
    this.$store.dispatch('onAuthStateChanged').then((user) => {
        this.UserLogin = user
        if (user) {
            this.$store.dispatch('getUserInfo')
        }else {
            this.goMenu()
        }
    })
  },
  computed: {
    UserInfo () {
      return this.$store.getters.UserInfo
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/profile/Profile.vue